import { render } from "./UploadPlus.vue?vue&type=template&id=4397a07c"
import script from "./UploadPlus.vue?vue&type=script&lang=js"
export * from "./UploadPlus.vue?vue&type=script&lang=js"

import "./UploadPlus.vue?vue&type=style&index=0&id=4397a07c&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__